import React, { useMemo, forwardRef, useImperativeHandle } from 'react'

import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import PropTypes from 'prop-types'

import PopoverMui from '@material-ui/core/Popover'

const Controller = forwardRef((props, ref) => {
  const {
    Component,
    ComponentProps,
    anchorOrigin,
    transformOrigin,
    children,
    popupState,
    popoverStyle
  } = props

  const trigger = useMemo(
    () => bindTrigger(popupState),
    [popupState]
  )

  const popover = useMemo(
    () => bindPopover(popupState),
    [popupState]
  )

  useImperativeHandle(ref, () => ({ ...popover }))

  return (
    <div>
      <Component
        { ...ComponentProps }
        { ...trigger }
      />

      <PopoverMui
        { ...popover }
        anchorOrigin={ anchorOrigin }
        transformOrigin={ transformOrigin }
        style={ { ...popoverStyle } }
      >
        {children}
      </PopoverMui>
    </div>
  )
})

const Popover = forwardRef((props, ref) => (
  <PopupState variant="popover" popupId={ props.popoverId }>
    {(popupState) => <Controller ref={ ref } { ...props } popupState={ popupState } />}
  </PopupState>
))

Popover.propTypes = {
  popoverId: PropTypes.string.isRequired,
  Component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  ComponentProps: PropTypes.object,
  popoverStyle: PropTypes.object,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 'top' | 'center' | 'bottom' | Number
    horizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) // 'left' | 'center' | 'right' | Number
  }),
  transformOrigin: PropTypes.shape({
    vertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 'top' | 'center' | 'bottom' | Number
    horizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) // 'left' | 'center' | 'right' | Number
  }),
  children: PropTypes.any
}

Popover.defaultProps = {
  ComponentProps: {},
  popoverStyle: {},
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center'
  },
  children: null
}

Controller.propTypes = {
  ...Popover.propTypes,
  popupState: PropTypes.object.isRequired
}

Controller.defaultProps = { ...Popover.defaultProps }

export default Popover
